/** @format */

export interface InstanceObject {
  instanceId: string
  instanceName: string
  instanceIP?: string
}

export const childTypeMap = {
  '39': [
    {
      childName: '子节点',
      childType: 129
    }
  ],
  '97': [
    {
      childName: '主实例',
      childType: 97
    },
    {
      childName: '只读实例',
      childType: 98
    }
  ],
  '99': [
    {
      childName: '主实例',
      childType: 99
    },
    {
      childName: '数据节点',
      childType: 100
    },
    {
      childName: '代理节点',
      childType: 101
    },
    {
      childName: '代理节点(聚合)',
      childType: 103
    }
  ],
  '109': [
    {
      childName: '实例节点',
      childType: 106
    }
  ],
  '114': [
    {
      childName: '实例',
      childType: 114
    },
    {
      childName: '域名',
      childType: 107
    }
  ],
  '119': [
    {
      childName: '代理实例',
      childType: 116
    }
  ],
  '96': [
    {
      childName: 'TiDB',
      childType: 120
    },
    {
      childName: 'TiKV',
      childType: 121
    },
    {
      childName: 'TiFlash',
      childType: 122
    },
    {
      childName: 'PD',
      childType: 123
    },
    {
      childName: 'TiCDC',
      childType: 124
    }
  ],
  '131': [
    {
      childName: '独享型LB',
      childType: 131
    },
    {
      childName: '监听器(HTTP)',
      childType: 139
    },
    {
      childName: '监听器(HTTPS)',
      childType: 140
    },
    {
      childName: '监听器(QUIC)',
      childType: 141
    },
    {
      childName: '监听器(TCP)',
      childType: 155
    },
    {
      childName: '监听器(UDP)',
      childType: 156
    },
    {
      childName: '监听器(TCPSSL)',
      childType: 157
    }
  ],
  '18': [
    {
      childName: '通道',
      childType: 18
    },
    {
      childName: '隧道',
      childType: 137
    }
  ],
  '142': [
    {
      childName: '集群',
      childType: 142
    },
    {
      childName: '系统盘',
      childType: 151
    },
    {
      childName: '数据盘',
      childType: 152
    }
  ],
  '159': [
    {
      childName: '实例',
      childType: 159
    },
    {
      childName: '域名',
      childType: 160
    }
  ],
  '165': [
    {
      childName: 'Mongos',
      childType: 166
    },
    {
      childName: 'Shard节点',
      childType: 168
    }
  ],
  '169': [
    {
      childName: '节点',
      childType: 170
    }
  ],
  '177': [
    {
      childName: '分片',
      childType: 178
    }
  ],
  '178': [
    {
      childName: '节点',
      childType: 179
    }
  ]
}

// 抽屉类型
export enum DRAWER_TYPE {
  'monitor' = 'monitor', // 告警策略详情
  'alarm' = 'alarm' //监控项详情
}
export type DrawerType = 'monitor' | 'alarm'

// 告警策略详情抽屉 && 监控项详情抽屉
export interface DrawerProps {
  productType?: string
  type: DrawerType
  instanceName: string
  instanceId: string
  visible: boolean
  closeDrawer: () => void
  className?: string
}

// 抽屉state
export interface DrawerObject {
  drawerType: DrawerType
  visible: boolean
  drawerInstance?: InstanceObject
}
// 抽屉默认state
export const initDrawerObject: DrawerObject = {
  drawerType: undefined,
  visible: false,
  drawerInstance: {
    instanceId: '',
    instanceName: ''
  }
}

export interface RouteParams {
  productType: string
  topType: string
  instanceId: string
  instanceName: string
  regionName?: string
}

// 需要展示自定义聚合实例产品类型
export const customInstanceProductType = [22, 150]
export const handleCustomInstance = productType => customInstanceProductType.includes(productType)

export interface ChildType {
  childType: number
  childName: string
}

export interface IContextType {
  productType?: string
  tabsList?: any[]
  setTabsValue?: (productType: string, value: string) => void
  topType?: string
  childTypes?: ChildType[]
  childTypeValue?: ChildType
  setChildTypeValue?: (value: ChildType) => void
}

export interface IChartContextType {
  curProduct?: { title: string; productType: number; link: string } // 主产品
  nameSpace?: string
  regionName?: string // region
  instanceId?: string // 主实例ID
  instanceName?: string // 主实例name
  topType?: number // topType
  childTypes?: ChildType[] // 子产品类型list
  childTypeValue?: ChildType // 当前子产品类型value
  subInstanceList?: InstanceObject[] // 子产品类型下实例list
  currentInstance?: InstanceObject // 当前选中子实例（2级）
  shardList?: InstanceObject[] // 分片节点list（MongoDB分片集群-Shard节点【53】）
  shardValue?: InstanceObject // 当前分片节点value
  setChartContext?: (value) => void // 修改context
}
